import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()

// 获取好友列表
export function getFriendList (args) {
	let url = BASE_API + '/chatroom/v2/friend/list'
	return axiosGetHandler(url, args)
}

// 发送好友申请
export function addFriend (args, formdata) {
	// 特殊处理， 因为小黑盒接口是application/x-www-form-urlencoded;charset=UTF-8，需要对数组做一个特殊处理
	if(formdata.friend_ids && Array.isArray(formdata.friend_ids)) {
		formdata['friend_ids'] = formdata['friend_ids'].join(',')
	}
	let url = BASE_XHH + '/bbs/app/profile/friend/batch_add'
	return axiosPostHandler(url, args, formdata)
}

// 回应好友申请
export function responseAddFriend (args, formdata) {
	let url = BASE_XHH + '/bbs/app/profile/friend/resp'
	return axiosPostHandler(url, args, formdata)
}

// 解除好友关系
export function deleteFriendV2 (args, formdata) {
	let url = BASE_XHH + '/bbs/app/profile/friend/del'
	return axiosPostHandler(url, args, formdata)
}

// 获取推荐列表
export function getRecommendFriend (args) {
	let url = BASE_API + '/chatroom/v2/friend/recommend'
	return axiosGetHandler(url, args)
}

// 获取用户信息
export function getUserInfo (args) {
	let url = BASE_API + '/chatroom/v2/account/info'
	return axiosGetHandler(url, args)
}

// 通过用户ID获取用户基础信息
export function getUserBasic (args) {
	let url = BASE_API + '/chatroom/account/get_heybox_id_basis'
	return axiosGetHandler(url, args)
}

// 通过用户ID或昵称获取用户基础信息
export function searchUserBasic (args) {
	let url = BASE_API + '/chatroom/account/search_user'
	return axiosGetHandler(url, args)
}

//获取置顶好友列表
export function getTopFriendList (args) {
  let url = BASE_API + '/chatroom/v2/friend/top'
  return axiosGetHandler(url, args)
}

//置顶好友id全量更新
export function updateTopFriendList (args, formdata) {
  let url = BASE_API + '/chatroom/v2/friend/top'
  return axiosPostHandler(url, args, formdata)
}
//添加至黑名单
export function blockUser(args, formdata) {
  let url = BASE_API + '/chatroom/v2/friend/blacklist'
  return axiosPostHandler(url, args, formdata)
}

//获取黑名单列表
export function getUserBlacklist(args) {
  let url = BASE_API + '/chatroom/v2/friend/blacklist'
  return axiosGetHandler(url, args)
}

// 获取好友申请信息
export function getFriendsRequests(args) {
  let url = BASE_API + '/chatroom/v2/friend/waiting'
  return axiosGetHandler(url, args)
}

/**
 * 获取最近消息列表 v4
 * @see https://app.apifox.com/link/project/6486200/apis/api-382535732
 * @param {*} args 
 * @returns 
 */
export function getRecentMsg(args) {
  let url = BASE_API + '/chatroom/v4/msg/talk/list'
  return axiosGetHandler(url, args)
}

// 获取个人卡片里面的游戏数据详情
export function getUserGameTheme (args) {
	let url = BASE_XHH + '/game/get_theme_details/'
	return axiosGetHandler(url, args)
}


// 聊天记录完成
export function completeMsg(args,formdata) {
	let url = BASE_API + '/chatroom/v2/msg/talk_list/remove'
	return axiosPostHandler(url, args, formdata)  
}

// 获取小黑盒好友列表
export function getHeyboxFriendList (args) {
  let url = BASE_API + '/chatroom/friend/heybox'
  return axiosGetHandler(url, args)
}

// 获取 Steam 好友列表
export function getSteamFriends(args, formdata) {
	let url = BASE_API + '/chatroom/v2/friend/steam'
	return axiosPostHandler(url, args, formdata)
}

// 获取简版好友列表
export function getSimpleFriendList(args) {
	let url = BASE_API + '/chatroom/v2/friend/simple'
	return axiosGetHandler(url, args)
}

// 获取好友分页列表
export function getFriendPageList(args) {
	let url = BASE_API + '/chatroom/v2/friend/page'
	return axiosGetHandler(url, args)
}


// 获取邀请弹窗中的好友列表
export function getInviteFriendList(args) {
  let url = BASE_API + '/chatroom/v2/friend/interactive/latest'
  return axiosGetHandler(url, args)
}

// 判断是否为好友关系
export function checkIsFriends(args, formdata) {
  let url = BASE_API + '/chatroom/v2/friend/check'
  return axiosPostHandler(url, args, formdata)
}